<div flexLayout="column" flexLayoutAlign="start stretch">
  <ng-container
    [ngTemplateOutlet]="template"
    [ngTemplateOutletContext]="{
     recipients: recipients$ | async,
  }"
    >
  </ng-container>
</div>

<ng-template #template let-recipients="recipients">
  <div flexLayout="column" flexLayoutAlign="start stretch" flexLayoutGap="1rem">
    <div flexLayout="row" flexLayoutAlign="start center" flexLayoutGap="1rem" class="recipientsBox">
      <span>Recipients</span>
      <mat-chip-list
        flex
        flexLayout="row"
        flexLayoutAlign="start center"
        #chipList
        aria-label="Recipients selection"
        >
        <div flex flexLayout="row wrap" flexLayoutAlign="start center">
          @for (recipient of recipients; track recipient) {
            <mat-chip
              flexLayout="row"
              flexLayoutAlign="start center"
              >
              <span>{{ recipient }}</span>
              <button type="button" matChipRemove (click)="removeRecipient(recipient)">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
          }
        </div>
      </mat-chip-list>
      <div flexLayout="row" flexLayoutAlign="end center">
        <button
          type="button"
          mat-icon-button
          color="primary"
          matTooltip="Add Specialty"
          (click)="addNewRecipient()"
          >
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>
</ng-template>
